import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChipBase from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { MediaType } from "stores/ApplicationFilters/Filters/MediaType";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const MediaTypesChips = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    return applicationFiltersStore.mediaTypes.map((mediaType) => (
        <AppliedFilterChipBase
            key={mediaType}
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() => applicationFiltersStore.toggleMediaType(mediaType)}
        >
            {MediaType.toString(mediaType)}
        </AppliedFilterChipBase>
    ));
});
